import { hasInjectionContext, inject, type Plugin } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export type ToastProps = {
  message?: string
  type?: ToastType
  duration?: number
  title: string
  actionText?: string
  onAction?: () => void
}

type ToastPlugin = (props: ToastProps) => void

let showToastFn: (props: ToastProps) => void

export function init(showFunction: (props: ToastProps) => void) {
  showToastFn = showFunction
}

function toast(props: ToastProps): void {
  if (!showToastFn) {
    // eslint-disable-next-line no-console
    console.warn('ToastWrapper not added in the app')
    return
  }
  return showToastFn(props)
}

export function useToast() {
  return hasInjectionContext() ? inject<ToastPlugin>('toast', toast) : toast
}

export const ToastPlugin: Plugin = {
  install(app) {
    app.provide('toast', toast)
  }
}
